var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(" Functie bewerken ")]),
      _c(
        "w-scroll-view",
        { style: { flexGrow: 1, flexShrink: 1 } },
        [
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: {
                          label: "Naam",
                          placeholder: "Functie naam",
                          "has-error": !_vm.nameValid,
                        },
                        model: {
                          value: _vm.func.Name,
                          callback: function ($$v) {
                            _vm.$set(_vm.func, "Name", $$v)
                          },
                          expression: "func.Name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-textarea", {
                        attrs: { label: "Omschrijving" },
                        model: {
                          value: _vm.func.Description,
                          callback: function ($$v) {
                            _vm.$set(_vm.func, "Description", $$v)
                          },
                          expression: "func.Description",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("w-card-title", [_vm._v(" Parameters ")]),
          _c("app-frontend-func-parameter-list", {
            attrs: { params: _vm.func.Params },
            on: {
              valid: function ($event) {
                _vm.paramNamesValid = $event
              },
            },
          }),
          _c("w-card-title", [_vm._v("Code")]),
          _c("codemirror", {
            ref: "codeEditor",
            staticClass: "grow",
            attrs: { options: _vm.cmOptions },
            model: {
              value: _vm.func.Code,
              callback: function ($$v) {
                _vm.$set(_vm.func, "Code", $$v)
              },
              expression: "func.Code",
            },
          }),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(" Annuleren ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check", disabled: !_vm.valid },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(" Bevestigen ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }